import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Paper,
  Divider,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { encryptMessages, showToast, WEBSERVICE, handleDefaultAssetPair } from "../../CoreDataService";
import { useChat } from "../../Services/ChatService";
import { useOtp } from "../../Contexts/OtpContext";

const Otp = () => {
  const { sendSmartMobileOtp } = useOtp();
  const { makeUserOnline } = useChat();
  const navigate = useNavigate();
  const { brokerBasicInfo, brokerDetailedInfo } = useSelector((state) => state);
  const [countdown, setCountdown] = useState(300);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showPhoneNumber, setShowPhoneNumber] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
  } = useForm();

  const emailcode = watch("emailcode");
  const phoneOtp = watch("phoneOtp");
  const lastSubmittedOtp = useRef("");

  useEffect(() => {
    if (countdown > 0) {
      const timer = setInterval(() => setCountdown((prev) => prev - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [countdown]);

  useEffect(() => {
    setPhoneNumber(localStorage.getItem("phoneUsedForRegistration"));
    setShowPhoneNumber(localStorage.getItem("phoneNumberActiveStatus") === "1");
  }, []);

  const backgroundStyle =
    brokerDetailedInfo?.color?.isBackgroundImage === 0
      ? {
        background: `linear-gradient(90deg, ${brokerDetailedInfo?.color?.backgroundColor1} 0%, ${brokerDetailedInfo?.color?.backgroundColor2} 60%)`,
      }
      : {
        backgroundImage: `url(${brokerDetailedInfo?.color?.backgroundImageLink})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      };

  const isRequesting = useRef(false);

  const setLoginData = useCallback(
    async (data) => {
      const accessToken = data.token;
      const uuid = data.userResult.uuid;

      localStorage.setItem("access_token", accessToken);
      localStorage.setItem("uuid", uuid);

      const userObj = { userId: data.userResult.userId, uuid };
      const userJsonString = JSON.stringify(userObj);

      const response = await axios.post(
        `${WEBSERVICE}user/GetUserDetails`,
        userJsonString,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      const dataRecheck = response.data;
      if (dataRecheck.error.error_data === 0) {
        const userDetails = dataRecheck.userResult;
        const myDate = new Date();
        myDate.setMonth(myDate.getMonth() + 12);

        document.cookie = `Username=${userDetails.firstName};expires=${myDate};domain=.paybito.com;path=/`;
        document.cookie = `userId=${userDetails.userId};expires=${myDate};domain=.paybito.com;path=/`;
        document.cookie = `ssecca=${accessToken};expires=${myDate};domain=.paybito.com;path=/`;

        localStorage.setItem("user_name", userDetails.firstName);
        localStorage.setItem("email", userDetails.email);
        localStorage.setItem("profile_pic", userDetails.profilePic);
        localStorage.setItem(
          "tier2SubmissionDate",
          userDetails.tier2SubmitDate || ""
        );
        localStorage.setItem(
          "tier3SubmissionDate",
          userDetails.tier3SubmitDate || ""
        );
        localStorage.setItem(
          "tier2ApprovedDate",
          userDetails.tier2ApprovedDate || ""
        );
        localStorage.setItem(
          "tier3ApprovedDate",
          userDetails.tier3ApprovedDate || ""
        );

        localStorage.setItem("user_name", userDetails.firstName);
        localStorage.setItem("first_name", userDetails.firstName);
        localStorage.setItem("last_name", userDetails.lastName);
        localStorage.setItem("middle_name", userDetails.middleName);
        localStorage.setItem("user_id", userDetails.userId);
        localStorage.setItem("userId", userDetails.userId);
        // document.cookie = cookieName1 + "=" + userDetails.userId + ";expires=" + myDate + ";domain=.paybito.com;path=/";
        localStorage.setItem("email", userDetails.email);
        localStorage.setItem("profile_pic", userDetails.profilePic);
        localStorage.setItem("check_id_verification_status", "true");
        const pair = dataRecheck?.defaultAssetPair || dataRecheck?.userResult?.defaultAssetPair;
        if (pair) {
          handleDefaultAssetPair(pair, true);
        } else {
          localStorage.setItem("selected_currency", "btc");
          localStorage.setItem("buying_crypto_asset", "btc");
          localStorage.setItem("O_buying_crypto_asset", "btc");
          localStorage.setItem("selling_crypto_asset", "usdt");
          localStorage.setItem("O_selling_crypto_asset", "usdt");
        }
        localStorage.setItem("UserTiretype", userDetails.userTierType);
        localStorage.setItem("exist2FaKey", userDetails.exist2FaKey);
        localStorage.setItem("userCountry", userDetails.country);
        if (localStorage.getItem("BROKERID") === userDetails.brokerId) {
          console.log("");
        } else {
          // console.log("brokerId--> 5", userDetails.brokerId);
          localStorage.setItem("BROKERID", userDetails.brokerId);
        }

        navigate("/identity-verification");
      } else {
        showToast("error", "Unable to fetch user details.");
      }
    },
    [navigate]
  );

  const callFcmTokenRegister = useCallback(async (token, uuid) => {
    console.log("in calling fcm token");

    const userObj = {
      platform: "WEB",
      uuid: uuid,
      token: localStorage.getItem("fcmToken"),
      audience: "TRADER",
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}notification/updateFCMToken`,
        JSON.stringify(userObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + token,
          },
        }
      );

      console.log("FCM token registered:", response.data);
    } catch (error) {
      console.error("Error registering FCM token:", error);
    }
  }, []);

  const onSubmit = useCallback(
    async (data) => {
      if (isRequesting.current) return;
      isRequesting.current = true;
      const payload = {
        brokerId: brokerBasicInfo.brokerId,
        email: localStorage.getItem("emailForUser"),
        otp: data.emailcode,
        userId: localStorage.getItem("userId"),
      };
      if (showPhoneNumber) {
        payload.phoneOtp = data.phoneOtp;
      }

      try {
        const response = await axios.post(
          `${WEBSERVICE}user/CheckOTP`,
          payload
        );
        if (response?.data?.error?.error_data === 0) {
          showToast("success", "OTP verified successfully");
          localStorage.setItem(
            "signup_user_id",
            response?.data?.userResult.user_id
          );
          const res = response?.data;

          callFcmTokenRegister(res?.token, res?.userResult?.uuid);
          localStorage.setItem("token", res?.token);
          localStorage.setItem("uuid", res?.userResult?.uuid);
          localStorage.setItem("userId", res?.userResult?.userId);
          makeUserOnline({
            userId: encryptMessages(res?.userResult?.userId),
          });
          setLoginData(res);
        } else {
          showToast("error", response?.data?.error?.error_msg);
        }
      } catch {
        showToast("error", "Something went wrong. Please try again.");
      } finally {
        isRequesting.current = false;
      }
    },
    [
      brokerBasicInfo,
      showPhoneNumber,
      callFcmTokenRegister,
      makeUserOnline,
      setLoginData,
    ]
  );

  useEffect(() => {
    if (isSubmitting) return;

    const currentOtp = showPhoneNumber ? `${emailcode}-${phoneOtp}` : emailcode;

    if (showPhoneNumber) {
      if (emailcode?.length === 8 && phoneOtp?.length === 8) {
        if (currentOtp !== lastSubmittedOtp.current) {
          lastSubmittedOtp.current = currentOtp;
          handleSubmit(onSubmit)();
        }
      }
    } else {
      if (emailcode?.length === 8) {
        if (currentOtp !== lastSubmittedOtp.current) {
          lastSubmittedOtp.current = currentOtp;
          handleSubmit(onSubmit)();
        }
      }
    }
  }, [
    emailcode,
    phoneOtp,
    showPhoneNumber,
    handleSubmit,
    isSubmitting,
    onSubmit,
  ]);

  const handleResendOTP = () => {
    resendOtp();
    if (showPhoneNumber) {
      handleSendOtpInSms();
    }
  };

  const resendOtp = async () => {
    setCountdown(300);
    const payload = {
      userId: localStorage.getItem("userId"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/ResendOTP/registration`,
        payload
      );
      if (response?.data?.error?.error_data === 0) {
        showToast("success", "OTP has been sent to your email");
      } else {
        showToast("error", response?.data?.error?.error_msg);
      }
    } catch {
      showToast("error", "Something went wrong. Please try again.");
    }
  };

  const handleSendOtpInSms = async () => {
    const payload = {
      phone: localStorage.getItem("phoneUsedForRegistration"),
      countryCode: localStorage.getItem("phoneCountryUsedForRegistration"),
    };
    try {
      await sendSmartMobileOtp(payload, "registration");
      return true;
    } catch (error) {
      return false;
    }
  };

  const textFieldStyles = {
    mt: 1,
    input: {
      color: "#333",
      "&::placeholder": {
        color: "#aaa",
        opacity: 1,
      },
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      "& fieldset": {
        borderColor: "#ccc",
      },
      "&:hover fieldset": {
        borderColor: "#888",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#1976d2",
      },
    },
    "& .MuiFormHelperText-root": {
      mt: 0.5,
    },
    "& label": {
      color: "#333",
      "&.Mui-focused": {
        color: "#1976d2",
      },
    },
  };

  return (
    <Box
      sx={{
        ...backgroundStyle,
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: 6,
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={6}
          sx={{
            p: 4,
            borderRadius: 3,
            backgroundColor: "#fff",
            height: {
              xs: showPhoneNumber ? "600px" : "430px",
              md: showPhoneNumber ? "600px" : "430px",
            },
            // width: "85%",
          }}
        >
          <Typography
            variant="h5"
            align="center"
            sx={{ color: "#333", fontWeight: 600, mb: 1 }}
          >
            {brokerBasicInfo.exchange} - OTP Verification
          </Typography>

          <Divider sx={{ mb: 3 }} />

          <form onSubmit={handleSubmit(onSubmit)} noValidate>
            {showPhoneNumber && (
              <>
                <Typography
                  variant="body1"
                  sx={{ color: "#000", mb: 2, fontSize: "15px" }}
                >
                  We sent a text message to you at {phoneNumber}. Enter the
                  eight digit code in that message to confirm your phone number.
                </Typography>

                <TextField
                  fullWidth
                  label="Enter code sent to registered phone number"
                  type="number"
                  className="black-autofill"
                  autoComplete="off"
                  variant="outlined"
                  sx={textFieldStyles}
                  {...register("phoneOtp", { required: "Code is required" })}
                  onInput={(e) => {
                    e.target.value = Math.max(0, parseInt(e.target.value))
                      .toString()
                      .slice(0, 8);
                  }}
                  error={!!errors.phoneOtp}
                  helperText={errors.phoneOtp?.message}
                />
              </>
            )}

            <Typography
              variant="body1"
              sx={{ color: "#000", mb: 2, mt: 2, fontSize: "15px" }}
            >
              Enter code sent to registered email address
            </Typography>

            <TextField
              fullWidth
              label="Enter OTP"
              type="number"
              className="black-autofill"
              autoComplete="off"
              variant="outlined"
              sx={textFieldStyles}
              {...register("emailcode", { required: "Code is required" })}
              onInput={(e) => {
                e.target.value = Math.max(0, parseInt(e.target.value))
                  .toString()
                  .slice(0, 8);
              }}
              error={!!errors.emailcode}
              helperText={errors.emailcode?.message}
            />

            <Typography
              variant="body2"
              sx={{
                color: countdown > 0 ? "#000" : "#1976d2",
                mb: 2,
                mt: 1,
                pt: 2,
                cursor: countdown > 0 ? "default" : "pointer",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: countdown > 0 ? "center" : "flex-end",
                  width: "100%",
                }}
              >
                {countdown > 0 ? (
                  `Resend in ${countdown} seconds`
                ) : (
                  <Button
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={() => countdown === 0 && handleResendOTP()}
                  >
                    Resend OTP
                  </Button>
                )}
              </Box>
            </Typography>

            <Typography
              variant="caption"
              sx={{
                color: "#000",
                mb: 3,
                display: "block",
                textAlign: "start",
                fontSize: "14px",
                paddingTop: "10px",
                lineHeight: "1.5",
              }}
            >
              *One-time password sent to your email occasionally takes longer to
              receive depending on email server rules.
            </Typography>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={
                isSubmitting ||
                (showPhoneNumber
                  ? emailcode?.length !== 8 || phoneOtp?.length !== 8
                  : emailcode?.length !== 8)
              }
              sx={{
                backgroundColor:
                  brokerDetailedInfo?.color?.buttonColor || "#1976d2",
                textTransform: "none",
                fontWeight: "bold",
                borderRadius: 1,
                py: 1,
                mt: 2,
                color: "#fff",
              }}
            >
              Submit
            </Button>
          </form>
        </Paper>
      </Container>
    </Box>
  );
};

export default Otp;
